import { productService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    filterInitialized: false,
    loading: true,
    items: {},
    filter: {},
    defaultFilter: {
      name: null,
      productType: null,
      orderByColumn: 'name',
      orderByDescending: false
    },
    currentPage: 1,
    meta: {}
  }
}

const actions = {
  initialize ({ commit }) {
    commit('initialize')
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  getListData ({ commit }) {
    commit('getListDataRequest')

    productService.getListData(state.all.filter, state.all.currentPage)
      .then(
        data => {
          commit('getListDataSuccess', data.result)
          return data.result
        }
      )
  },

  getAll ({ commit }) {
    return productService.getAll()
      .then(
        data => {
          commit('getAllSuccess', data.result)
          return data.result
        }
      )
  },

  getById ({ commit }, id) {
    return productService.getById(id)
      .then(data => {
        return data.result
      })
  },

  create ({ commit, dispatch }, product) {
    return productService.create(product)
      .then(product => {
        commit('createSuccess', product.result)
        dispatch('getListData')
        return product.result
      }).catch(error => {
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, product) {
    return productService.update(product)
      .then(product => {
        commit('updateSuccess', product.result)
        return product.result
      }).catch(error => {
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit, dispatch }, id) {
    commit('deleteRequest', id)

    productService.delete(id)
      .then(product => {
        commit('deleteSuccess', id)
        dispatch('getListData')
      })
  }
}

const getters = {
  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.page = null
    defaultFilter.page = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
  },

  initialize (state) {
    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  // Get all
  getListDataRequest (state) {
    state.all.loading = true
  },

  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },

  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  getAllSuccess (state, data) {
    state.all.items = data.items
  },

  // Create
  createSuccess (state, updatedContact) {
    /*
    state.all.items = state.all.items.map(contact =>
      contact.contactId === updatedcontact.contactId ? updatedcontact : contact
    )
    */
    Vue.prototype.$toast('Produkt skapad', 'success')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa produkt', 'error')
  },

  // Update
  updateSuccess (state, updatedProduct) {
    state.all.items = state.all.items.map(product =>
      product.productId === updatedProduct.productId ? updatedProduct : product
    )

    Vue.prototype.$toast('Produkt uppdaterad', 'success')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera produkten', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to contact being deleted
    state.all.items = state.all.items.map(product =>
      product.productId === id
        ? { ...product, deleting: true }
        : product
    )
  },
  deleteSuccess (state, id) {
    // remove deleted contact from state
    state.all.items = state.all.items.filter(product => product.productId !== id)
  }
}

export const products = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/product.module.js